import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Config";
import { ConfirmDialog } from "primereact/confirmdialog";
import OrderTableListaEspera from "../components/OrderTableListaEspera";
import FormEditarListaEspera from "../components/FormEditarListaEspera";
import ListaEsperaTipoProductoChart from '../components/ListaEsperaTipoProductoChart';
import { Dialog } from "primereact/dialog";
import FormCrearCliente from "../../client/components/FormCrearCliente";
import {
  getListaEspera,
  updateListaEspera,
} from "../../../services/ListaEsperaService.js";
import { getCotizacionById, crearCotizacion } from "../../../services/CotizacionService.js";
import { getClienteById } from "../../../services/ClienteService.js";

const ListaEspera = () => {
  const navigate = useNavigate();
  const [listaEspera, setListaEspera] = useState([]);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [selectedListaEspera, setSelectedListaEspera] = useState(null);
  const [id, setId] = useState("");
  const {baseUrl, headerText } = useGlobalContext();
  const idUsuario = sessionStorage.getItem("usuario_id");
  const [metrajeRequerido, setMetrajeRequerido] = useState("");
  const [idTipoProducto, setIdTipoProducto] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [empresa, setEmpresas] = useState(null);
  const [estado, setEstado] = useState("");
  const [prioridad, setPrioridad] = useState("");
  const [observaciones, setObservaciones] = useState("");

  const fetchData = async () => {
    try {

        setLoading(true);
        try {
          const data = await getListaEspera(baseUrl);
          setListaEspera(data.listaEspera);

        } catch (error) {
          console.error("Error fetching lista de espera:", error);
        } finally {
          setLoading(false);
        }

    } catch (error) {
      console.error("Error al obtener la lista de espera:", error);
    }
  };

  useEffect(() => {
    
      setGlobalFilterValue('');
      fetchData();
    
  }, [baseUrl]);


  const handleEditListaEspera = (listaEspera) => {
    setSelectedListaEspera(listaEspera);
    setIdCliente(listaEspera.idCliente);
    setIdTipoProducto(listaEspera.idTipoProducto);
    setMetrajeRequerido(listaEspera.metraje_requerido);
    setId(listaEspera.id);
    setShowEditDialog(true);
    setEstado(listaEspera.estado);
    setPrioridad(listaEspera.prioridad);
    setObservaciones(listaEspera.observaciones);
  };

  const handleSaveEditListaEspera = async () => { 
    try {
      setLoading(true);
      const updatedListaEspera = { 
        id: selectedListaEspera.id,
        estado: estado,
        prioridad: prioridad,
        observaciones: observaciones,
        empresa: empresa,
        idCliente: idCliente,
        idTipoProducto: idTipoProducto,
        metrajeRequerido: metrajeRequerido,
        idUsuario: idUsuario
      };
      await saveListaEsperaAPI(updatedListaEspera);
      
      setListaEspera({ idCliente: "", idTipoProducto: "", metrajeRequerido: ""});
      setShowEditDialog(false);

      fetchData();
    } catch (error) {
      console.error("Error al actualizar la lista de espera:", error);
      alert(error.message || "Error al actualizar la lista de espera");
    }
  };

  const handleConvertListaEspera = async (listaEspera) => {
    try {
      // console.log(listaEspera);
      setLoading(true);

      const updatedListaEspera = { 
         id: listaEspera.id,
         estado: "CONVERTIDA",
         prioridad: listaEspera.prioridad,
         observaciones: listaEspera.observaciones,
         idUsuario: idUsuario,
         metrajeRequerido: listaEspera.metraje_requerido,
       };
      await saveListaEsperaAPI(updatedListaEspera);
      
      try {
        setLoading(true);

        const dataCotizacion = await getCotizacionById(baseUrl, listaEspera.id_cotizacion);

        if (dataCotizacion.cotizacion.estado.estado === "ASIGNACIÓN" || dataCotizacion.cotizacion.estado.estado === "APROBACIÓN" ||
          dataCotizacion.cotizacion.estado.estado === "RECHAZADA" || dataCotizacion.cotizacion.estado.estado === "ANULADA" ||
          dataCotizacion.cotizacion.estado.estado === "ELIMINADA" || dataCotizacion.cotizacion.estado.estado === "RENOVACIÓN"
        ) { // Si la cotización esta asignada, se crea una nueva
            const data = await crearCotizacion(baseUrl, {
              idCliente: listaEspera.id_cliente,
              idCreador: idUsuario,
              empresaArrendadora: listaEspera.cliente.nombre,
            });
            const newUrl = `/selectProductos?idCotizacion=${data.idCotizacion}&idCliente=${listaEspera.id_cliente}&selected=true&activeIndex=1`;
            navigate(newUrl);
        } else { // Si la cotización no esta asignada, se redirecciona a la cotización existente
            const newUrl = `/selectProductos?idCotizacion=${listaEspera.id_cotizacion}&idCliente=${listaEspera.id_cliente}&selected=true&activeIndex=1`;
            navigate(newUrl);
        }
        
      } catch (error) {
          alert(error.message || "Hubo un error al redireccionar la cotización");
          return;
      }
    } catch (error) {
      console.error("Error al actualizar la lista de espera:", error);
      alert(error.message || "Error al actualizar la lista de espera");
    } finally {
      setLoading(false);
      setListaEspera({ idCliente: "", idTipoProducto: "", metrajeRequerido: ""});
      setShowEditDialog(false);
    }
  };

  const handleDeleteListaEspera = async (listaEspera) => {
    try {
      setLoading(true);
      const updatedListaEspera = { 
        id: listaEspera.id,
        estado: "CANCELADA",
        prioridad: listaEspera.prioridad,
        observaciones: listaEspera.observaciones,
        idUsuario: idUsuario,
        metrajeRequerido: listaEspera.metraje_requerido,
      };

      await saveListaEsperaAPI(updatedListaEspera);
      
      setListaEspera({ idCliente: "", idTipoProducto: "", metrajeRequerido: ""});
      setShowEditDialog(false);
      fetchData();
    } catch (error) {
      console.error("Error al actualizar la lista de espera:", error);
      alert(error.message || "Error al actualizar la lista de espera");
    }
  };

  const saveListaEsperaAPI = async (listaEspera) => {
    return await updateListaEspera(baseUrl, listaEspera, headerText);
  };

  // Persistir nuevo orden (prioridad) tras reordenar en OrderList
  const handleReorderPrioridad = async (nuevoOrden) => {
    try {
      setLoading(true);
      await Promise.all(
        (Array.isArray(nuevoOrden) ? nuevoOrden : []).map((item, index) => {
          const updatedListaEspera = {
            id: item.id,
            estado: item.estado,
            prioridad: index + 1, 
            observaciones: item.observaciones,
            idUsuario: idUsuario,
            metrajeRequerido: item.metraje_requerido
          };
          return saveListaEsperaAPI(updatedListaEspera);
        })
      );
      await fetchData(); // recargar para reflejar el orden desde BD
    } catch (error) {
      console.error("Error al reordenar prioridades:", error);
      alert(error.message || "Error al actualizar el orden de la lista");
    } finally {
      setLoading(false);
    }
  };

  // Diálogo local para editar cliente (FormCrearCliente)
  const [isClienteDialogVisible, setIsClienteDialogVisible] = useState(false);
  const [clienteEditData, setClienteEditData] = useState(null);

  const openClienteEditor = async (idCliente) => {
    try {
      const data = await getClienteById(baseUrl, idCliente);
      if (data) {
        setClienteEditData(data);
        setIsClienteDialogVisible(true);
      } else {
        alert("No se encontró información del cliente");
      }
    } catch (error) {
      console.error("Error al obtener cliente por ID:", error);
      alert("Error al cargar el cliente para edición.");
    }
  };

  const handleWhatsappListaEspera = (listaEspera) => {
    const contactos = listaEspera?.cliente?.contactos ?? [];
  
    const confirmAndRedirect = (reason) => {
      const msg =
        reason === "no-contact"
          ? "El cliente no tiene contacto con teléfono. ¿Deseas abrir el editor de Cliente para agregar/editar el contacto aquí?"
          : "El número de teléfono del contacto es inválido. ¿Deseas abrir el editor de Cliente para corregirlo aquí?";
      if (window.confirm(msg)) {
        openClienteEditor(listaEspera?.cliente?.id);
      }
    };
  
    // Validación: sin contactos
    if (!Array.isArray(contactos) || contactos.length === 0) {
      confirmAndRedirect("no-contact");
      return;
    }

    
  
    // Tomar contacto con teléfono (o el primero como fallback)
    const contactoConTelefono = contactos.find((c) => !!c?.telefono) ?? contactos[0];
    const telefonoOriginal = contactoConTelefono?.telefono ?? "";
  
    // Normalización del teléfono a formato WhatsApp Chile
    const normalizePhoneForWhatsApp = (value) => {
      const digits = String(value).replace(/\D/g, "");
      if (!digits) return "";
      if (digits.startsWith("56")) return digits;                 // ya internacional
      if (digits.startsWith("0")) return `56${digits.slice(1)}`;  // elimina 0 inicial
      if (digits.length === 9 && digits.startsWith("9")) return `56${digits}`; // celular CL
      return digits;
    };
  
    const phoneParam = normalizePhoneForWhatsApp(telefonoOriginal);
    const isValidPhone = phoneParam.startsWith("56") && phoneParam.length >= 11;
  
    // Validación: número inválido
    if (!isValidPhone) {
      confirmAndRedirect("invalid-phone");
      return;
    }
  
    // Confirmación adicional: mostrar número, contacto y cliente
    const formatDisplayPhone = (digits) => {
      if (digits.startsWith("56") && digits.length >= 11) {
        const local = digits.slice(2); // 9 dígitos
        return `+56 ${local.slice(0, 1)} ${local.slice(1, 5)} ${local.slice(5)}`;
      }
      return digits;
    };
    const clienteNombre = listaEspera?.cliente?.razon_social || listaEspera?.cliente?.nombre || "—";
    const contactoNombre = contactoConTelefono?.nombre || "—";
    const displayPhone = formatDisplayPhone(phoneParam);
    const confirmMsg =
      `Vas a enviar WhatsApp a ${displayPhone}.\n` +
      `Contacto: ${contactoNombre}\nCliente: ${clienteNombre}\n\n` +
      `Aceptar para enviar, Cancelar para editar el cliente.`;
  
    if (!window.confirm(confirmMsg)) {
      openClienteEditor(listaEspera?.cliente?.id);
      return;
    }

    // Construcción del mensaje
    const productos =
      (listaEspera?.tipos_producto ?? [])
        .map((tp) => tp?.descripcion)
        .filter(Boolean)
        .join(", ") || "";
  
    const mensaje = `Hola ${contactoNombre}, tu solicitud de ${productos} está disponible para ser cotizada.`;
  
    // Abrir WhatsApp
    const url = `https://wa.me/${phoneParam}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  //CABECERA
  return (
    <div className="grid">

      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Lista de Espera</h4>
          <h6 style={{ marginTop: "5px" }}>¿Qué solicitudes están en espera?</h6>
        </div>
      </div>

      <div className="col-12">
        <div className="card">
          <OrderTableListaEspera
            listaEspera={listaEspera}
            loading={loading}
            globalFilterValue={globalFilterValue}
            handleEditListaEspera={handleEditListaEspera}
            handleDeleteListaEspera={handleDeleteListaEspera}
            handleConvertListaEspera={handleConvertListaEspera}
            handleReorderPrioridad={handleReorderPrioridad}
            handleWhatsappListaEspera={handleWhatsappListaEspera}
          />
          {/* Dialog externo: Editar Solicitud */}
          <FormEditarListaEspera
              visible={showEditDialog}
              onHide={() => setShowEditDialog(false)}
              prioridad={prioridad}
              setPrioridad={setPrioridad}
              observaciones={observaciones}
              setObservaciones={setObservaciones}
              loading={loading}
              onSave={handleSaveEditListaEspera}
              metrajeRequerido={metrajeRequerido}
              setMetrajeRequerido={setMetrajeRequerido}
          />
          {/* Dialog local: FormCrearCliente en modo edición */}
          <Dialog
            visible={isClienteDialogVisible}
            onHide={() => setIsClienteDialogVisible(false)}
            style={{ width: "85vw" }}
            closable
            modal
          >
            <FormCrearCliente
              modoEdicion={true}
              clienteData={clienteEditData}
              onSuccess={() => {
                setIsClienteDialogVisible(false);
                fetchData(); // refrescar lista si cambian contactos/datos
              }}
              onError={(error) => {
                console.error("Error:", error);
                alert("Ha ocurrido un error al procesar la operación");
              }}
              onClose={() => {
                setIsClienteDialogVisible(false);
              }}
            />
          </Dialog>
          <ConfirmDialog/>
        </div>
        <div className="card">
            <ListaEsperaTipoProductoChart data={listaEspera} initialCollapsed />
        </div>
      </div>
    </div>
  );
};
export default ListaEspera;
